var _module_exports = "<span>Save chart to a dashboard</span>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/signalflowv2/chart/saveChartToDashboardTooltip.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;